module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="result-header">\n	<div class="result-header__inner">\n		<div class="result-header__status"><span class="loader"></span><span class="label">Your filter returned 4 of the 12 available gateways</span></div>\n		<div class="result-header__options">\n		</div>\n	</div>\n</div>\n\n<div class="list-region"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/groups/list/templates/layout.html
// module id = 447
// module chunks = 0